import React from 'react';
import { fetchListViewConfigurations } from '../libs/listViewRequests';
import type { ListViewConfiguration } from '../listview/types';

interface ListViewConfigurationsData {
  configurations: ListViewConfiguration[];
  configurationsFetched: boolean;
  errorCode: number | false;
}

const initialData: ListViewConfigurationsData = {
  configurations: [],
  configurationsFetched: false,
  errorCode: false
};

const useListViewConfigurations = (host: string): ListViewConfigurationsData => {
  const [data, setData] = React.useState(initialData);

  React.useEffect(() => {
    let cancelled = false;
    fetchListViewConfigurations(host, (configurations, error) => {
      if (cancelled) return;
      setData({
        configurations: configurations || [],
        configurationsFetched: true,
        errorCode: error ? error.code : false
      });
    });
    return () => {
      cancelled = true;
    };
  }, [host]);

  return data;
};

export default useListViewConfigurations;
